import { useEffect, useRef } from 'react';

export default function useFocusTrap(enabled, focusRefs, onEscape) {
	const wasEnabledRef = useRef(false);

	useEffect(() => {
		if (!enabled) {
			wasEnabledRef.current = false;
			return;
		}

		const focusableElements = focusRefs
			.map((ref) => ref.current)
			.filter(Boolean);

		if (!wasEnabledRef.current && focusableElements.length > 0) {
			focusableElements[0].focus();
		}
		wasEnabledRef.current = true;

		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				event.preventDefault();
				onEscape();
				return;
			}

			if (event.key !== 'Tab') {
				return;
			}

			const currentElements = focusRefs
				.map((ref) => ref.current)
				.filter(Boolean);

			if (currentElements.length === 0) {
				return;
			}

			const firstElement = currentElements[0];
			const lastElement = currentElements[currentElements.length - 1];

			if (event.shiftKey && document.activeElement === firstElement) {
				event.preventDefault();
				lastElement.focus();
				return;
			}

			if (!event.shiftKey && document.activeElement === lastElement) {
				event.preventDefault();
				firstElement.focus();
			}
		};

		window.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [enabled, focusRefs, onEscape]);
}
